export const Reports = [
  {
    id: 'mparAIR',
    title: 'MPAR Actionable Intelligence Report',
    desc: 'The MPAR AIR uses the BDX login as the email for the report. Additional emails can be added after the report is sent to prevent spamming. The facility id for each site can be found on the MPAR Report. Request more than one report for multi facility customer IDNs.',
    input: 'Facility ID for Report',
    url: '/email/mpar-air',
  },
  {
    id: 'mparBatteryIssues',
    title: 'MPAR Battery Issues Report',
    desc: 'The Battery Issues Report uses the BDX login as the email for the report. Additional emails can be added after the report is sent to prevent spamming. The facility id for each site can be found on the MPAR Report. Request more than one report for multi facility customer IDNs.',
    input: 'Facility ID for Report',
    url: '/email/battery',
  },
  {
    id: 'mparDrawerMaps',
    title: 'MPAR Drawer Maps',
    desc: 'The MPAR Drawer Maps Report uses the BDX login as the email for the report. Additional emails can be added after the report is sent to prevent spamming. The facility id for each site can be found on the MPAR Report. Request more than one report for multi facility customer IDNs.',
    input: 'Facility ID for Report',
    url: '/email/mpar-drawer',
  },
  {
    id: 'mparPM',
    title: 'MPAR Proactive Maintenance',
    desc: 'The MPAR PM uses the BDX login as the email for the report. Additional emails can be added after the report is sent to prevent spamming. The facility id for each site can be found on the MPAR Report. Request more than one report for multi facility customer IDNs.',
    input: 'Facility ID for Report',
    url: '/email/mpar-pm',
  },
  {
    id: 'mparReport',
    title: 'MPAR Report Card',
    desc: 'The MPAR Report Card uses the BDX login as the email for the report. Additional emails can be added after the report is sent to prevent spamming. The facility id for each site can be found on the MPAR Report. Request more than one report for multi facility customer IDNs.',
    input: 'Facility ID for Report',
    url: '/email/mpar-report',
  },
  {
    id: 'mparBatchReport',
    title: 'MPAR Batch Report Card',
    desc: 'The MPAR Report Card uses the BDX login as the email for the report. Additional emails can be added after the report is sent to prevent spamming. The facility id for each site can be found on the MPAR Report. Request more than one report for multi facility customer IDNs.',
    input: 'Customer ID for Batch Reports',
    url: '/email/mpar-batch-report',
  },
  {
    id: 'MPAR Component Errors',
    title: 'mpar Components',
    desc: 'facility itemized errors mainly for NotOnBus',
    input: 'Facility ID for Report',
    url: '/email/mparComponents',
  },
  {
    id: 'mparSuggestedPockets',
    title: 'MPAR Suggested Pockets',
    desc: 'The MPAR Suggested Pocket Report uses the BDX login as the email for the report. Additional emails can be added after the report is sent to prevent spamming. The facility id for each site can be found on the MPAR Report. Request more than one report for multi facility customer IDNs.',
    input: 'Facility ID for Report',
    url: '/email/mpar',
  },
  {
    id: 'timeUsability',
    title: 'Time Customer Suggested Downtime',
    desc: 'The Time Customer Suggested Downtime uses the BDX login as the email for the report. Additional emails can be added after the report is sent to prevent spamming. The facility id for each site can be found on the Time Customer Suggested Downtime. Request more than one report for multi facility customer IDNs.',
    input: 'Facility ID for Report',
    url: '/email/time-usability',
  },
  {
    id: 'timecustomeroverview',
    title: 'Time Customer Products and Versions',
    desc: 'The Time Customer Product Versions and Recommendations.',
    input: 'Facility ID for Report',
    url: '/email/time-customer-overview',
  },
]
